import { CheckCircleIcon, ReceiptIcon, TrashIcon } from '@phosphor-icons/react';
import React from 'react';

import { ActionMenuItem } from '../../../../components/dialog/ActionMenuItem';
import { BulkActionsDialog } from '../../../../components/dialog/BulkActionsDialog';
import { ISelfBillBulkActions } from './useSelfBillBulkActions';
import { countSelfBills, type ISelfBillKindConfig } from '../self-bill-kind-config';

interface ISelfBillBulkActionsMenuProps {
  config: ISelfBillKindConfig;
  selectionCount: number;
  bulk: ISelfBillBulkActions;
}

export const SelfBillBulkActionsMenu: React.FC<ISelfBillBulkActionsMenuProps> = (props) => {
  const { config, selectionCount, bulk } = props;

  return (
    <BulkActionsDialog isOpen={bulk.isOpen} onClose={bulk.close} selectionCount={selectionCount} isBusy={bulk.isBusy}>
      <ActionMenuItem
        onTrigger={() => {
          bulk.close();
          bulk.approveDialog.open();
        }}
        isDisabled={!bulk.hasDraft || bulk.isBusy}
        iconLeft={<CheckCircleIcon className="w-4 h-4" />}
      >
        Goedkeuren...
        {bulk.hasDraft && selectionCount !== bulk.draftCount && (
          <span className="text-fg-muted ml-1">
            ({bulk.draftCount} concept{bulk.draftCount === 1 ? '' : 'en'})
          </span>
        )}
      </ActionMenuItem>
      <ActionMenuItem
        onTrigger={bulk.handleDiscard}
        isDisabled={!bulk.hasDraft || bulk.isBusy}
        isDanger
        iconLeft={<TrashIcon className="w-4 h-4" />}
      >
        Verwijder concepten
        {bulk.hasDraft && selectionCount !== bulk.draftCount && (
          <span className="text-fg-muted ml-1">
            ({bulk.draftCount} concept{bulk.draftCount === 1 ? '' : 'en'})
          </span>
        )}
      </ActionMenuItem>
      <ActionMenuItem
        onTrigger={() => {
          bulk.close();
          bulk.convertToPurchasesDialog.open();
        }}
        isDisabled={!bulk.hasSent || bulk.isBusy}
        iconLeft={<ReceiptIcon className="w-4 h-4" />}
      >
        Omzetten naar AKF
        {bulk.hasSent && selectionCount !== bulk.sentCount && (
          <span className="text-fg-muted ml-1">({countSelfBills(config, bulk.sentCount)} verzonden)</span>
        )}
      </ActionMenuItem>
    </BulkActionsDialog>
  );
};
